<script>
import { http } from 'App/http';

export default {
    props: {
        offer: {
            required: true,
            type: Object
        },

        showImmediately: {
            required: false,
            default: false,
        },

        brandName: {
            required: true,
            type: String
        },
    },

    data() {
        return {
            accepted: false,
        }
    },

    mounted() {
        if (this.showImmediately) {
            setTimeout(() => {
                this.showModal();
            }, 2000);
        }

        this.$event_bus.$on('showFreeOfferModal', () => {
            this.showModal();
        });
    },

    methods: {
        showModal() {
            $('#free-months').modal('show');
            $('#free-months').on('hidden.bs.modal', () => {
                this.snoozeOffer();

                $('#free-months').off('hidden.bs.modal');
            });
        },

        activateOffer() {
            http.post(`/app/free-months-offers/${this.offer.id}/activate`)
                .then(({ data }) => {
                    this.accepted = true;
                    this.$event_bus.$emit('showSubscriptionForm');
                    this.$store.commit('auth/setFreeMonths', data.user.bank);
                }).catch(error => {});
        },

        snoozeOffer() {
            if (this.accepted) {
                return;
            }

            http.post(`/app/free-months-offers/${this.offer.id}/snooze`)
                .catch(error => {});
        },

        deleteOffer() {
            http.delete(`/app/free-months-offers/${this.offer.id}`)
                .then(response => {
                    $('#free-months').modal('hide');
                }).catch(error => {});
        }
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },

        firstName() {
            let fullName = this.user ? this.user.realname : '';

            return fullName.split(' ')[0];
        },

        getTrustpilotImagePath() {
            return this.$store.getters.isNordhealthBrand ? '/images/offers/trustpilot-stars-nordhealth.svg' : '/images/offers/trustpilot-stars.png';
        },

        getFreeOfferImagePath() {
            return this.$store.getters.isNordhealthBrand ? '/images/offers/free_offering_nordhealth.svg' : '/images/offers/free-offering.png';
        },
    }
}
</script>

<template>
    <div id="free-months" class="modal fade free-months" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;">
        <div class="card-box with-image text-center modal-dialog p-0 shadow">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            <div class="flex-grow free-months-main">
                <img :src="getFreeOfferImagePath" class="m-b-10 img-hero" />
                <h4>{{ transChoice('subscription.free_months.header', offer.number_of_months, { name: firstName, months: offer.number_of_months, brand_name: brandName }) }}</h4>
                <p class="text-muted">{{ trans('subscription.free_months.details_1') }} <span v-sanitize-html="transChoice('subscription.free_months.details_2', offer.number_of_months, { months: offer.number_of_months, brand_name: brandName })"></span></p>
                <a href="" class="btn btn-custom full-width p-10 p-l-20 p-r-20 m-t-10 m-b-10" @click.prevent="activateOffer">
                    <span>{{ transChoice('subscription.free_months.cta', offer.number_of_months, { months: offer.number_of_months }) }}</span>
                </a>
                <small ><a href="" @click="deleteOffer" class="text-muted" style="text-decoration: underline;">{{ trans('subscription.free_months.dont_show') }}</a></small>
            </div>
            <div class="flex flex-column free-months-side">
                <div class="flex-grow flex flex-column hidden-xs">
                    <img :src="trans('subscription.free_months.reviewer_photo_url')">
                    <img :src="getTrustpilotImagePath" class="img-trustpilot m-t-10">
                    <h5>{{ trans('subscription.free_months.reviewer_name') }}</h5>
                    <p class="italic">“{{ trans('subscription.free_months.reviewer_text') }}”</p>
                </div>
                <small class="text-muted">{{ trans('subscription.free_months.disclaimer_1') }} <span v-sanitize-html="trans('subscription.free_months.disclaimer_2')"></span></small>
            </div>
        </div>
    </div>
</template>
